import { Root } from './Root'
import { Description } from './Description'
import { Action } from './Action'
import { Details } from './Details'
import { Icon } from './Icon'
import toast from 'react-hot-toast'
import { isValidElement, ReactNode } from 'react'

export const Toast = {
  Root,
  Icon,
  Description,
  Action,
  Details,
}

export type DismissToast = () => void

export const TOAST_CONTAINER_CLASS = 'blaze-toast-container'

export const showToast = (
  Message: ReactNode,
  durationInSeconds: number,
  key?: string,
  onClose?: () => void,
): DismissToast => {
  const id = toast.custom(() => (isValidElement(Message) ? Message : null), {
    id: key,
    duration: durationInSeconds === 0 ? Infinity : durationInSeconds * 1000,
  })

  let dismissed = false
  const dismiss = () => {
    if (dismissed) return
    dismissed = true
    toast.remove(id)
    onClose?.()
  }

  if (onClose && durationInSeconds > 0) {
    setTimeout(dismiss, durationInSeconds * 1000)
  }

  return dismiss
}

export const dismissToastMessages = () => toast.remove()
